import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      class: "parking-svg-fill"
    }, [
      _createElementVNode("path", { d: "M20.495 1.03H3.65a2.58 2.58 0 0 0-2.578 2.578v16.844A2.58 2.58 0 0 0 3.65 23.03h16.844a2.58 2.58 0 0 0 2.578-2.578V3.608a2.58 2.58 0 0 0-2.578-2.578m.859 19.422a.86.86 0 0 1-.86.859H3.652a.86.86 0 0 1-.86-.86V3.609a.86.86 0 0 1 .86-.86h16.844a.86.86 0 0 1 .859.86z" }),
      _createElementVNode("path", { d: "M13.428 5.334H7.29v13.39h1.754v-4.806h4.384c2.417 0 4.384-1.926 4.384-4.292s-1.967-4.292-4.384-4.292zm.052 6.696H8.835V7.05h4.645c1.537 0 2.787 1.117 2.787 2.49s-1.25 2.49-2.787 2.49" })
    ], -1)
  ])))
}
export default { render: render }